import mainLocationsStore from "@mobx/store/locations";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import ReactCardFlip from "react-card-flip";
import EquipmentTemplates from "../EquipmentTemplates";
import RackTemplates from "../RackTemplates";
import styles from "./AdditionalRackFeatures.module.scss";

export interface IAdditionalRackFeatures3Props {
  readonly show: boolean;
}

const AdditionalRackFeatures3 = observer((props: IAdditionalRackFeatures3Props) => {
  const buildingStore = mainLocationsStore.activeLocation?.activeBuilding;
  return (
    <div
      className={cn(styles.container, {
        [styles.show]: props.show,
      })}
    >
      <ReactCardFlip
        containerClassName={styles.wrapper}
        isFlipped={buildingStore?.isFlipped}
      >
        <RackTemplates isFlipped={!!buildingStore?.isFlipped} isShown={props.show} />
        <EquipmentTemplates isFlipped={!!buildingStore?.isFlipped} />
      </ReactCardFlip>
    </div>
  );
});

AdditionalRackFeatures3.displayName = "AdditionalRackFeatures3";

export default AdditionalRackFeatures3;
